import {Component, OnInit, Inject} from '@angular/core';
import {WimdModalsService} from './wimd-modals.service';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';


@Component({
  selector: 'app-wimd-modal',
  templateUrl: './wimd-modal.component.html',
  styleUrls: ['./wimd-modal.component.css']
})
export class WimdModalComponent implements OnInit {

  constructor(private wimdModalsService: WimdModalsService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.wimdModalsService.getMedia(data.projectId, data.mediaType, data.passageId).subscribe(
      (media: any) => {
        switch (data.mediaType) {
          case 'video':
            this.source = media[0];
            break;
          case 'image':
            this.source = media.Image;
            break;
        }
        this.isLoading = false;

      }
    );
  }

  ngOnInit(): void {
  }

  source: any;
  isLoading: boolean = true;


}
